module.exports = __webpack_public_path__ + "img/2.ba4bd2e5.jpg";